import { Routes, Route, Navigate } from "react-router-dom";
import { lazy } from "react";
import PatientHealthForm from "../screens/PatientRole/PatientHealthForm";

// ONLY Receptionist
const PatientDashboard = lazy(() =>
  import("../screens/PatientRole/PatientDashboard")
);
const PatientForm = lazy(() => import("../screens/PatientRole/PatientForm"));

export default function PatientRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PatientDashboard />} />
      <Route path="register-form" element={<PatientForm />} />
      <Route path="/health-form/:clientId" element={<PatientHealthForm />} />

      <Route path="*" element={<Navigate to="/patient" replace />} />
    </Routes>
  );
}
